// import { createDecorator } from "vue-class-component";
import { vueStoreConfig } from './utils';
import Component from 'vue-class-component';
// export const SubModule = createDecorator((options, key) => {
//   // component options should be passed to the callback
//   // and update for the options object affect the component
//   vuestoreConfig(options).submodules.push(key);
// });
export function SubModule(target, key) {
    // property getter
    const getter = function () {
        return this.$options.$vuestore.submodules[key];
    };
    // property setter
    const setter = function (newVal) {
        this.$options.$vuestore.submodules[key] = newVal;
    };
    // Create new property with getter and setter
    Object.defineProperty(target, key, {
        get: getter,
        set: setter,
        enumerable: true,
        configurable: true
    });
}
export const AbstractStore = Component;
export function Store(target) {
    const comp = Component(target);
    comp.options.$vuestore = { name, submodules: {}, interceptors: [] };
    return comp;
}
// export function inAction(ctx: any, name: string, fn: Function) {
//   const paramNames = $args(fn);
//   // tslint:disable-next-line:only-arrow-functions
//   return function(...args: any[]) {
//     const payload = {};
//     for (let i = 0; i < paramNames.length; i++) payload[paramNames[i]] = args[i];
//     const result = fn.apply(ctx, args);
//     vuestoreConfig(ctx.$options).actionListeners.forEach(l => l({ type: name, payload }));
//     return result;
//   }();
// }
// export function QuietMutation(_: any, key: string | symbol, descriptor: any) {
//   return doMutation(_, key, descriptor, true);
// }
export function Mutation(_, key, descriptor) {
    return doMutation(_, key, descriptor, false);
}
function doMutation(_, key, descriptor, quiet) {
    const original = descriptor.value;
    const paramNames = $args(original);
    descriptor.value = function actionInterceptor(...args) {
        const config = vueStoreConfig(this);
        if (!config)
            throw new Error('The class that owns this @Mutation is not a Store. Did you add @Store?');
        const listeners = config.interceptors;
        if (!listeners || listeners.length === 0)
            return original.apply(this, args);
        const payload = {};
        for (let i = 0; i < paramNames.length; i++)
            payload[paramNames[i]] = args[i];
        const mutation = () => {
            const result = original.apply(this, args);
            if (result && result.then)
                throw new Error(`Mutation '${key.toString()}' cannot be async`);
        };
        const listener = listeners.reduce((fn, l) => {
            return () => l({ type: 'mutation', handler: fn, name: key, payload, quiet });
        }, mutation);
        listener();
    };
}
function $args(func) {
    return (func + '')
        .replace(/[/][/].*$/mg, '') // strip single-line comments
        .replace(/\s+/g, '') // strip white space
        .replace(/[/][*][^/*]*[*][/]/g, '') // strip multi-line comments
        .split('){', 1)[0].replace(/^[^(]*[(]/, '') // extract the parameters
        .replace(/=[^,]+/g, '') // strip any ES6 defaults
        .split(',').filter(Boolean); // split & filter [""]
}
//# sourceMappingURL=annotations.js.map